<template>
  <div>
    <Title :pages="[{ icon: 'calendar-days', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalEjercicio
        v-if="create_access"
        :button_name="$t('Crear') + ' Ejercicio'"
        modal_title="Ejercicio Contable"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        :emitters="emitters"
        @updateDialog="updateDialog"
        @loadList="loadAll"
        :item="mainItem"
        @updateItem="(newItem) => { mainItem = newItem; }"
      />

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-4 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object></v-combobox>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="loadAll">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-alert v-if="list_access" dense text class="mt-3" :type="fecha_bloqueo != null ? 'warning' : 'info'">
        <span v-if="fecha_bloqueo != null">
          Fecha de bloqueo vigente: <b>{{ fecha_bloqueo }}</b>. No se puede crear ni editar ningún asiento con fecha anterior o igual.
        </span>
        <span v-else>Sin períodos cerrados: todos los asientos del emisor son editables.</span>
      </v-alert>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <div class="px-4 pt-2">
            <v-btn outlined small color="blue-grey" @click="toggleAll">
              <v-icon left small>{{ allExpanded ? "unfold_less" : "unfold_more" }}</v-icon>
              {{ allExpanded ? "Colapsar todo" : "Expandir todo" }}
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left">Desde</th>
                <th class="text-left">Hasta</th>
                <th class="text-left">Estado</th>
                <th class="text-left">Cerrado el</th>
                <th class="text-left">Asiento cierre</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="7" class="pa-0">
                  <v-progress-linear indeterminate color="primary" height="2"></v-progress-linear>
                  <div class="text-center py-6 grey--text">Cargando...</div>
                </td>
              </tr>
              <tr v-else-if="visibleRows.length === 0">
                <td colspan="7">
                  <v-alert :value="true" color="error" icon="warning" class="ma-2">
                    {{ search != "" ? "Busqueda sin resultados - " + search : "El emisor no tiene ejercicios contables." }}
                  </v-alert>
                </td>
              </tr>

              <!-- Ejercicio -->
              <template v-for="row in visibleRows">
                <tr v-if="row.type === 'ejercicio'" :key="row.key" class="ejercicio-row">
                  <td style="white-space: nowrap">
                    <v-icon v-if="row.hasChildren" small class="mr-1 toggle-icon" @click="toggleExpand(row.item.id)">
                      {{ row.expanded ? "expand_more" : "chevron_right" }}
                    </v-icon>
                    <v-icon v-else small class="mr-1" color="grey lighten-1">remove</v-icon>
                    <span class="font-weight-bold">{{ row.item.name }}</span>
                    <span class="ml-2 grey--text text--darken-1">({{ row.children_count }})</span>
                  </td>
                  <td>{{ row.item.date_from }}</td>
                  <td>{{ row.item.date_to }}</td>
                  <td>
                    <v-chip x-small :color="row.item.state === 'cerrado' ? 'red' : 'green'" dark>{{ row.item.state }}</v-chip>
                  </td>
                  <td>{{ row.item.closed_at || "-" }}</td>
                  <td>{{ row.item.asiento_cierre ? "N° " + row.item.asiento_cierre.number : "-" }}</td>
                  <td class="text-center px-0" style="white-space: nowrap">
                    <v-tooltip bottom v-if="row.item.state === 'abierto' && periodo_create_access">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small color="blue-grey" class="mr-2" @click="generatePeriodos(row.item)">event_repeat</v-icon>
                      </template>
                      <span>Generar períodos mensuales</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.state === 'abierto' && periodo_create_access">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small color="teal" class="mr-2" @click="newPeriodo(row.item)">add</v-icon>
                      </template>
                      <span>Agregar período</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.state === 'abierto'">
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="update_access" v-on="on" small color="orange" class="mr-2" @click="confirmAction(row.item, 'close', 'ejercicio')">lock</v-icon>
                      </template>
                      <span>Cerrar ejercicio</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.state === 'cerrado'">
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="update_access" v-on="on" small color="green" class="mr-2" @click="confirmAction(row.item, 'reopen', 'ejercicio')">lock_open</v-icon>
                      </template>
                      <span>Reabrir ejercicio</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="update_access && row.item.state === 'abierto'" v-on="on" small color="blue" class="mr-2" @click="editItem(row.item)">edit</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="delete_access && row.item.state === 'abierto'" v-on="on" small color="red" class="mr-2" @click="askDelete(row.item, 'ejercicio')">delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </td>
                </tr>

                <!-- Períodos sin ejercicio (legacy: la FK es nullable) -->
                <tr v-else-if="row.type === 'huerfanos'" :key="row.key" class="ejercicio-row">
                  <td style="white-space: nowrap">
                    <v-icon small class="mr-1 toggle-icon" @click="toggleExpand(0)">
                      {{ row.expanded ? "expand_more" : "chevron_right" }}
                    </v-icon>
                    <span class="font-weight-bold orange--text text--darken-3">Sin ejercicio asignado</span>
                    <span class="ml-2 grey--text text--darken-1">({{ row.children_count }})</span>
                  </td>
                  <td colspan="5" class="grey--text text--darken-1">No se pueden cerrar. Eliminelos y vuelva a generarlos dentro de un ejercicio.</td>
                  <td></td>
                </tr>

                <!-- Período -->
                <tr v-else :key="row.key" class="periodo-row">
                  <td style="padding-left: 48px; white-space: nowrap">
                    <v-icon x-small class="mr-2" :color="row.orphan ? 'orange' : 'grey'">fiber_manual_record</v-icon>
                    {{ row.item.name }}
                  </td>
                  <td>{{ row.item.date_from }}</td>
                  <td>{{ row.item.date_to }}</td>
                  <td>
                    <v-chip x-small :color="row.item.state === 'cerrado' ? 'red' : 'green'" dark>{{ row.item.state }}</v-chip>
                  </td>
                  <td>{{ row.item.closed_at || "-" }}</td>
                  <td>-</td>
                  <td class="text-center px-0" style="white-space: nowrap">
                    <v-tooltip bottom v-if="row.item.state === 'abierto' && !row.orphan">
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="periodo_update_access" v-on="on" small color="orange" class="mr-2" @click="confirmAction(row.item, 'close', 'periodo')">lock</v-icon>
                      </template>
                      <span>Cerrar período</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.state === 'cerrado'">
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="periodo_update_access" v-on="on" small color="green" class="mr-2" @click="confirmAction(row.item, 'reopen', 'periodo')">lock_open</v-icon>
                      </template>
                      <span>Reabrir período</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="!row.orphan">
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="periodo_update_access && row.item.state === 'abierto'" v-on="on" small color="blue" class="mr-2" @click="editPeriodo(row.item)">edit</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-if="periodo_delete_access && row.item.state === 'abierto'" v-on="on" small color="red" class="mr-2" @click="askDelete(row.item, 'periodo')">delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <ModalPeriodo
        modal_title="Período Contable"
        :formBtn="periodoItem.id > 0 ? 'Editar' : 'Crear'"
        :dialog="dialog_periodo"
        :service="service"
        :ejercicio="periodo_ejercicio"
        :item="periodoItem"
        @updateDialog="updateDialogPeriodo"
        @loadList="loadAll"
        @updateItem="(newItem) => { periodoItem = newItem; }"
      />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />

      <DialogYesNo
        :open="dialog_action"
        :title="action_title"
        :message="action_message"
        nameCancel="Cancelar"
        nameAccept="Confirmar"
        @accept="executeAction"
        @cancel="dialog_action = false"
      />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import ModalEjercicio from "./Modal.vue";
import ModalPeriodo from "./ModalPeriodo.vue";

export default {
  components: { Title, ModalEjercicio, ModalPeriodo, DialogDelete, DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: generalService,
      page_title: "Ejercicios y Períodos",
      emitters: [],
      emitter_selected: null,
      dialog_action: false,
      dialog_periodo: false,
      action_type: null,
      action_target: null,
      action_item: null,
      delete_target: null,
      periodo_ejercicio: null,
      expandedIds: new Set(),
      mainItem: {
        id: "",
        name: "",
        date_from: "",
        date_to: "",
        emitter: null,
      },
      periodoItem: {
        id: "",
        name: "",
        date_from: "",
        date_to: "",
      },
      defaultItem: null,
      defaultPeriodoItem: null,
      list: [], // ejercicios
      periodos: [],
      loading: true, // evita el flash de "sin ejercicios" antes de la primera carga
      dialog_delete: false,
    };
  },
  computed: {
    periodo_create_access() {
      return this.getModuleAccess(Constant.SECTION_PERIODOS_CONTABLES, "create");
    },
    periodo_update_access() {
      return this.getModuleAccess(Constant.SECTION_PERIODOS_CONTABLES, "update");
    },
    periodo_delete_access() {
      return this.getModuleAccess(Constant.SECTION_PERIODOS_CONTABLES, "delete");
    },
    // Fecha de bloqueo del emisor = mayor date_to entre los períodos cerrados
    fecha_bloqueo() {
      const cerrados = this.periodos.filter((p) => p.state === "cerrado");
      if (cerrados.length === 0) return null;
      return cerrados.map((p) => p.date_to).sort().pop();
    },
    // Ids de los grupos expandibles (0 = grupo de períodos sin ejercicio)
    groupIds() {
      const ids = this.list.filter((e) => this.periodosOf(e.id).length > 0).map((e) => e.id);
      if (this.huerfanos.length > 0) ids.push(0);
      return ids;
    },
    allExpanded() {
      return this.groupIds.length > 0 && this.groupIds.every((id) => this.expandedIds.has(id));
    },
    // Períodos legacy sin ejercicio: la FK es nullable, no deben quedar ocultos
    huerfanos() {
      return this.sortByDate(this.periodos.filter((p) => p.ejercicio == null));
    },
    // Aplana ejercicio + períodos; con búsqueda expande automáticamente las ramas con match
    visibleRows() {
      const term = (this.search || "").toLowerCase();
      const rows = [];

      const pushGroup = (group, children) => {
        const matchGroup = term === "" || group.name.toLowerCase().includes(term);
        const matchChildren = term === "" ? children : children.filter((p) => (p.name || "").toLowerCase().includes(term));

        if (term !== "" && !matchGroup && matchChildren.length === 0) return;

        const expanded = term !== "" ? true : this.expandedIds.has(group.id);
        rows.push({
          key: group.key,
          type: group.type,
          item: group.item,
          hasChildren: children.length > 0,
          children_count: children.length,
          expanded: expanded,
        });

        if (expanded) {
          (matchGroup ? children : matchChildren).forEach((p) =>
            rows.push({ key: "p-" + p.id, type: "periodo", item: p, orphan: group.type === "huerfanos" })
          );
        }
      };

      this.list.forEach((ejercicio) => {
        pushGroup({ id: ejercicio.id, key: "e-" + ejercicio.id, type: "ejercicio", item: ejercicio, name: ejercicio.name || "" }, this.periodosOf(ejercicio.id));
      });

      if (this.huerfanos.length > 0) {
        pushGroup({ id: 0, key: "g-huerfanos", type: "huerfanos", item: null, name: "Sin ejercicio asignado" }, this.huerfanos);
      }

      return rows;
    },
    action_title() {
      const entidad = this.action_target === "ejercicio" ? "ejercicio" : "período";
      return (this.action_type === "close" ? "Cerrar " : "Reabrir ") + entidad;
    },
    action_message() {
      if (this.action_target === "ejercicio") {
        return this.action_type === "close"
          ? "¿Cerrar el ejercicio? Se generará el asiento de refundición de resultados. Todos los períodos deben estar cerrados."
          : "¿Reabrir el ejercicio? Se eliminará el asiento de refundición y volverá a estar editable.";
      }
      return this.action_type === "close"
        ? "¿Cerrar el período? Se bloqueará toda operación con fecha dentro o anterior al período."
        : "¿Reabrir el período? Las operaciones del rango volverán a ser editables.";
    },
  },
  watch: {
    // Al crear un ejercicio se propone el emisor del filtro
    dialog(open) {
      if (open && !(this.mainItem.id > 0) && this.mainItem.emitter == null) {
        this.mainItem.emitter = this.emitter_selected;
      }
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.defaultPeriodoItem = JSON.parse(JSON.stringify(this.periodoItem));
    this.loadEmitters();
  },
  methods: {
    loadEmitters() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.loadAll();
        } else {
          this.loading = false;
        }
      });
    },
    loadAll() {
      if (this.emitter_selected == null) return;

      this.loading = true;
      const param = { emitter: this.emitter_selected.id };

      Promise.all([
        generalService.filter(param, Constant.SECTION_EJERCICIOS),
        generalService.filter(param, Constant.SECTION_PERIODOS_CONTABLES),
      ])
        .then(([ejercicios, periodos]) => {
          this.list = ejercicios.result || [];
          this.periodos = periodos.result || [];
          // Al cargar se abren los ejercicios en curso (y los huérfanos, que requieren acción)
          const abiertos = this.list.filter((e) => e.state === "abierto").map((e) => e.id);
          if (this.huerfanos.length > 0) abiertos.push(0);
          this.expandedIds = new Set(abiertos);
        })
        .catch(() => this.$toast.error("Ocurrió un error al cargar los ejercicios.", "Error"))
        .finally(() => (this.loading = false));
    },
    // Ascendente: replica el orden en el que deben cerrarse
    sortByDate(periodos) {
      return periodos.slice().sort((a, b) => (a.date_from > b.date_from ? 1 : a.date_from < b.date_from ? -1 : 0));
    },
    periodosOf(ejercicio_id) {
      return this.sortByDate(this.periodos.filter((p) => p.ejercicio != null && p.ejercicio.id === ejercicio_id));
    },
    toggleExpand(id) {
      const next = new Set(this.expandedIds);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      this.expandedIds = next;
    },
    toggleAll() {
      this.expandedIds = this.allExpanded ? new Set() : new Set(this.groupIds);
    },
    newPeriodo(ejercicio) {
      this.periodo_ejercicio = ejercicio;
      this.periodoItem = JSON.parse(JSON.stringify(this.defaultPeriodoItem));
      this.dialog_periodo = true;
    },
    editPeriodo(periodo) {
      this.periodo_ejercicio = this.list.find((e) => e.id === periodo.ejercicio.id) || null;
      this.periodoItem = JSON.parse(JSON.stringify(periodo));
      this.dialog_periodo = true;
    },
    updateDialogPeriodo(value) {
      if (!value) {
        this.periodoItem = JSON.parse(JSON.stringify(this.defaultPeriodoItem));
        this.periodo_ejercicio = null;
      }
      this.dialog_periodo = value;
    },
    generatePeriodos(ejercicio) {
      generalService
        .query({}, Constant.SECTION_PERIODOS_CONTABLES + "/generate/" + ejercicio.id)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.loadAll();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch(() => this.$toast.error("Ocurrió un error.", "Error"));
    },
    confirmAction(item, type, target) {
      this.action_item = item;
      this.action_type = type;
      this.action_target = target;
      this.dialog_action = true;
    },
    executeAction() {
      const section = this.action_target === "ejercicio" ? Constant.SECTION_EJERCICIOS : Constant.SECTION_PERIODOS_CONTABLES;
      generalService
        .query({}, section + "/" + this.action_type + "/" + this.action_item.id)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.loadAll();
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch(() => this.$toast.error("Ocurrió un error.", "Error"))
        .finally(() => (this.dialog_action = false));
    },
    askDelete(item, target) {
      this.delete_target = target;
      this.deleteId = item.id;
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      const section = this.delete_target === "ejercicio" ? Constant.SECTION_EJERCICIOS : Constant.SECTION_PERIODOS_CONTABLES;
      generalService
        .remove({ id: this.deleteId }, section)
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.loadAll();
          } else {
            this.$toast.error(response.msg || response.message, "Error");
          }
        })
        .catch(() => this.$toast.error("Ocurrió un error.", "Error"))
        .finally(() => (this.dialog_delete = false));
    },
  },
};
</script>

<style scoped>
.toggle-icon {
  cursor: pointer;
}
.periodo-row td {
  background: #fafafa;
}
</style>
